export const sendCalendarSessionTypes = {
  REQUEST: 'CALENDAR_SESSION_SEND_REQUEST',
  SUCCESS: 'CALENDAR_SESSION_SEND_SUCCESS',
  FAILED: 'CALENDAR_SESSION_SEND_FAILED',
};
